import angular from 'angular';

import EntityLocalizationService from './entity-localization.service';

const EntityLocalizationModule = angular
    .module('control-room.commons.content.services.entity-localization', [])
    .service('crEntityLocalizationService', EntityLocalizationService);

export default EntityLocalizationModule;
